import _ from 'lodash';
import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { compose } from 'redux';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { withComponentId } from '../../../common/ComponentIdContext';
import { withComponentName } from '../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import TextBlink from '../../../common/table/TextBlink';
import { fetchListSummary, REDUCER_NAME } from '../reducer';
import { listHideColumn, listColumn } from './Const';
import { connect } from 'react-redux';
import {
  candleStickCalculation,
  DOWN,
  UP,
} from '../../../helpers/CandleStickCalculation';
import { getColorPrice } from '../../../helpers/Color';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';
import {
  formatPrice,
  formatTextFloat,
  formatVolume,
} from '../../../helpers/Text';
import CellHover from '../../watchlist/summary/CellHover';
import Table from '../../../common/table/Table';
import {
  getDataFollowKeyByDot,
  getSMA,
  syncComponentSelector,
  tradingTimeInterval,
} from '../../../helpers/Common';
import TradingViewUrl from '../../../common/TradingViewUrl';

const i18nTitleKey = 'topVolume.technical.technicalHeader';

const getClassName = (item, listColumn) => {
  return getColorPrice(
    getDataFollowKeyByDot(item, listColumn.PRICE),
    getDataFollowKeyByDot(item, listColumn.REF_PRICE),
    getDataFollowKeyByDot(item, listColumn.HIGH_PRICE),
    getDataFollowKeyByDot(item, listColumn.LOW_PRICE),
    'text',
  );
};

const candleStickCal = (item, listColumn) => {
  return candleStickCalculation(
    getDataFollowKeyByDot(item, listColumn.HIGH_PRICE),
    getDataFollowKeyByDot(item, listColumn.LOW_PRICE),
    getDataFollowKeyByDot(item, listColumn.OPEN_PRICE),
    getDataFollowKeyByDot(item, listColumn.PRICE),
    getDataFollowKeyByDot(item, listColumn.H1),
    getDataFollowKeyByDot(item, listColumn.L1),
    getDataFollowKeyByDot(item, listColumn.O1),
    getDataFollowKeyByDot(item, listColumn.C1),
    getDataFollowKeyByDot(item, listColumn.H2),
    getDataFollowKeyByDot(item, listColumn.L2),
    getDataFollowKeyByDot(item, listColumn.O2),
    getDataFollowKeyByDot(item, listColumn.C2),
    getDataFollowKeyByDot(item, listColumn.SMA20),
    getDataFollowKeyByDot(item, listColumn.SMA20Past4),
  );
};

const getTrend = trend => {
  if (trend === DOWN) {
    return <i className="icon-down-arrow fs-12 text-s-color-3" />;
  } else if (trend === UP) {
    return <i className="icon-up-arrow fs-12 text-s-color-5" />;
  }
};

const schema = () =>
  Object.keys(listColumn).map((item, index) => {
    const key = listColumn[item];
    const title = `${i18nTitleKey}.${item}`;

    const result = {
      key,
      title,
    };

    if (index === 0) {
      return {
        ...result,
        isString: true,
        render: (text, item) => (
          <CellHover organCode={item.organCode} isShowDeleteIcon={false}>
            <TextBlink item={item} tradingDate="priceInfo.tradingDate">
              <TradingViewUrl code={item.organCode} />
              &nbsp;{text}
            </TextBlink>
          </CellHover>
        ),
      };
    }

    if (_.includes([listColumn.VOLUME], key)) {
      return {
        ...result,
        render: (text, item) => {
          return (
            <TextBlink item={item} tradingDate="priceInfo.tradingDate">
              {formatTextFloat(formatVolume(text))}
            </TextBlink>
          );
        },
      };
    }

    if (_.includes([listColumn.PRICE], key)) {
      return {
        ...result,
        render: (text, item) => {
          const className = getClassName(item, listColumn);
          return (
            <TextBlink
              item={item}
              tradingDate="priceInfo.tradingDate"
              className={className}
            >
              {formatTextFloat(formatPrice(text))}
            </TextBlink>
          );
        },
      };
    }

    if (_.includes([listColumn.PERCENT_PRICE_CHANGE], key)) {
      return {
        ...result,
        render: (text, item) => {
          const className = getClassName(item, listColumn);
          return (
            <TextBlink
              item={item}
              tradingDate="priceInfo.tradingDate"
              className={className}
            >
              {formatTextFloat(text * 100)}%
            </TextBlink>
          );
        },
      };
    }

    if (_.includes([listColumn.RSI], key)) {
      return {
        ...result,
        render: (text, item) => {
          return (
            <TextBlink item={item} tradingDate="priceInfo.tradingDate">
              {formatTextFloat(text)}
            </TextBlink>
          );
        },
      };
    }

    if (_.includes([listColumn.CANDLE_STICK], key)) {
      return {
        disableSort: true,
        ...result,
        thStyle: { textAlign: 'left' },
        render: (text, item) => {
          const candleStickData = candleStickCal(item, listColumn);
          const trend = getTrend(candleStickData.trend);
          return (
            <TextBlink
              item={item}
              tradingDate="priceInfo.tradingDate"
              className="text-left"
            >
              {candleStickData.candleStick} {trend}
            </TextBlink>
          );
        },
      };
    }

    if (
      _.includes([listColumn.SMA20, listColumn.SMA50, listColumn.SMA100], key)
    ) {
      return {
        ...result,
        render: (text, item) => {
          if (!item.priceInfo || !item.priceInfo.matchPrice) {
            return <div className="pl-8 pr-8">--</div>;
          }
          const value = getSMA(text, item.priceInfo.matchPrice);
          return <div className={`${value} `}>{I18n.t(`common.${value}`)}</div>;
        },
      };
    }

    return {
      ...result,
      render: text => (
        <TextBlink item={item} tradingDate="priceInfo.tradingDate">
          {formatTextFloat(text, 0)}
        </TextBlink>
      ),
    };
  });

const getDataFromRedux = state => state[REDUCER_NAME].listSummaryTableByTicker;

class TableTechnical extends Component {
  componentDidMount() {
    const { watchListId, fetchListSummary } = this.props;
    this.intervalId = tradingTimeInterval(() => {
      fetchListSummary(watchListId);
    });
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  onRowClick = organCode => {
    const { listOrganizationByOrganCode, syncType } = this.props;
    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: listOrganizationByOrganCode[organCode],
    });
  };

  render() {
    const { ids, isFetching, table, sortState, onSort } = this.props;

    return (
      <Table
        clickRow={this.onRowClick}
        sortState={sortState}
        onSort={onSort}
        table={table}
        thValign="top"
        isLoading={isFetching}
        ids={ids}
        resizable={true}
        columnDraggable={false}
        rowDraggable={false}
        hideColumns={listHideColumn}
        getDataFromRedux={getDataFromRedux}
        schema={schema()}
      />
    );
  }
}

const mapStateToProps = (state, { componentName, componentId }) => ({
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
  syncType: syncComponentSelector(state, componentName, componentId),
  i18n: state.i18n,
  ids:
    state[REDUCER_NAME].sortedIds || state[REDUCER_NAME].listTickerSummaryTable,
  isFetching: state[REDUCER_NAME].isFetching,
  watchListId: state[REDUCER_NAME].watchListId,
});

const mapDispatchToProps = {
  fetchListSummary,
};

export default compose(
  withComponentId,
  withComponentName,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(TableTechnical);
